/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Created for Universe App Tools.
 * 
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.dialog",
  title: "Display a Dialog Box",
  description: "A fullscreen dialog box.",
  fields: {
    "inner": {
      title: "Inner",
      type: "inner", 
      description: "The body of the dialog box.",
      required: true
    },
    "title": {
      title: "Title",
      type: "inner", 
      description: "The title of the dialog box."
    },
    "footer": {
      title: "Footer",
      type: "inner", 
      description: "The footer of the dialog box.",
      default: ""
    }, 
    "allowclose": {
      title: "Allow Close",
      type: "boolean",
      description: "If true, the dialog will have a close button.",
      default: true
    },
    "fullscreen": {
      title: "Fullscreen",
      type: "boolean",
      description: "If true, renders the dialog as fullscreen.",
      default: true
    },
    "breadcrumb": {
      title: "Show Breadcrumb",
      type: "boolean",
      description: "If true, shows a small task breadcrumb at the top of the dialog.",
      default: true
    },
    "breadcrumbTitle": {
      title: "Breadcrumb Title",
      type: "string",
      description: "Optional breadcrumb title override for this dialog step."
    },
    "lockParent": {
      title: "Lock Parent",
      type: "boolean",
      description: "If true, background dialog layers are visible but non-interactive while this dialog is open.",
      default: true
    },
    "hide": {
      title: "Hide",
      type: "boolean",
      description: "If true, the dialog will be hidden by default.",
      default: false
    },
    "AlertStyle": {
      title: "Alert Style",
      type: "string",
      description: "The type of alert to use. Can be 'alert', 'confirm', or 'prompt'. Confirm will show a 'yes/no' dialog. Prompt will show a 'Continue/Cancel' options. Alert will show a simple 'close' button.",
      list: ["alert", "confirm", "prompt"]
    }
  },
  passthrough: true
});

// var namespace = "ua.dialog";
// exports.namespace = namespace;

var jsonRender = require("../interface/jsonRender.js");
var uai = require("../interface/interface.js");
var events = require("../../../uam/events.js");
// var uae = require("./templates/ua.element.js");

function toTitleText(value) {
  if (typeof value === "string") return value.trim();
  return "";
}

function escapeHtml(text) {
  return (text || "").toString()
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function updateDialogStackState() {
  if (typeof document === "undefined") return;

  var modals = Array.from(document.querySelectorAll(".modal.show"));
  if (modals.length === 0) return;

  var titles = [];
  for (var i = 0; i < modals.length; i++) {
    titles.push((modals[i].getAttribute("data-ua-dialog-title") || "").trim() || ("Step " + (i + 1)));
  }

  for (var m = 0; m < modals.length; m++) {
    var modal = modals[m];
    var isTop = (m === modals.length - 1);

    modal.classList.remove("ua-dialog-layer-locked");
    modal.classList.remove("ua-dialog-layer-active");

    if (isTop) {
      modal.classList.add("ua-dialog-layer-active");
      modal.setAttribute("aria-hidden", "false");
    } else {
      var topLockParent = modals[modals.length - 1].getAttribute("data-ua-lock-parent") !== "false";
      if (topLockParent) {
        modal.classList.add("ua-dialog-layer-locked");
        modal.setAttribute("aria-hidden", "true");
      } else {
        modal.classList.add("ua-dialog-layer-active");
        modal.setAttribute("aria-hidden", "false");
      }
    }

    var breadcrumb = modal.querySelector("[data-ua-dialog-breadcrumb]");
    if (!breadcrumb) continue;

    if (modal.getAttribute("data-ua-breadcrumb") === "false" || modals.length <= 1) {
      breadcrumb.innerHTML = "";
      breadcrumb.classList.add("d-none");
      continue;
    }

    var parts = [];
    for (var t = 0; t <= m; t++) {
      parts.push("<span>" + escapeHtml(titles[t]) + "</span>");
      if (t < m) {
        parts.push("<span class='ua-dialog-breadcrumb-sep'>></span>");
      }
    }

    breadcrumb.innerHTML = parts.join("");
    breadcrumb.classList.remove("d-none");
  }
}


// var required = ["inner", "image"]; 
// exports.required = required;

// exports.define = {
//   namespace: namespace,
//   title: "Dialog Module",
//   description: "A fullscreen dialog module.",
//   fields: {
//     "inner": {
//       type: "inner", 
//       description: "The body of the dialog box."
//     },
//     "title": {
//       type: "inner", 
//       description: "The title of the dialog box."
//     },
//     "footer": {
//       type: "inner", 
//       description: "The footer of the dialog box."
//     }, 
//     "allowclose": {
//       type: "boolean",
//       description: "If true, the dialog will have a close button.",
//       default: true
//     }
//   },
//   required: required
// } 



/**
 * We'll add the footnote to the footnotes for the page, and output the corresponding number
 * @param {*} options The json element to render the footnote on.
 * @returns The final renderalbe object, dom or ua/json.
 */
exports.render = async function (options) {

  // var options = json;
  var dialogTitle = toTitleText(options.breadcrumbTitle || options.title) || "Task";

  // var myid = false;

  var modalHeader = false;
  
  //If I options.allowclose = false, we won't render a close button or the id.

  if ("allowclose" in options) {
    if (!(options.allowclose)) {
      modalHeader = {
        n: "div",
        c: "modal-header p-1",
        i: [
          {
            n: "h1",
            c: "modal-title d-flex align-items-center",
            i: [
              options.title
            ]
          },
          {
            n: "div",
            c: "ua-dialog-breadcrumb",
            "data-ua-dialog-breadcrumb": "true",
            i: ""
          }
        ]
      }
    }
  }

  if (!(modalHeader)) { 
    // myid = uai.generateRandomID(8);
    modalHeader = {
      n: "div",
      c: "modal-header p-1",
      i: [
        {
          n: "div",
          c: "col-10",
          i: [
            {
              n: "h1",
              c: "modal-title d-flex align-items-center",
              i: [
                options.title
              ]
            },
            {
              n: "div",
              c: "ua-dialog-breadcrumb",
              "data-ua-dialog-breadcrumb": "true",
              i: ""
            }
          ]
        },
        {
          n: "div",
          c: "col-2 text-end",
          i: {
            n: "button",
            c: "btn btn-text-primary bg-background-hover text-hover modal-dia-close border-0", //text-shadow box-shadow",
            i: {
              n: "i",
              c: "bi bi-x-circle-fill",
              "data-ua-dismiss": "modal",
            },
            "data-bs-dismiss": "modal",
            "data-ua-dismiss": "modal",
            "aria-label": "Close"
          }
        }
      ]
    }
  }

  var mFooter = options.footer;
    //is there an alert style?
  if ("AlertStyle" in options) {
    switch (options.AlertStyle) {
      case "alert":

      //<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      //<button type="button" class="btn btn-primary">Save changes</button>
        mFooter = [{
          n: "div",
          c: "col-12 text-end",
          i: [{
            n: "button",
            c: "btn btn-primary modal-dia-close",
            "data-ua-dismiss": "modal",
            "aria-label": "Close",
            i: [{
              n: "i",
              c: "bi bi-x-circle-fill",
              "data-ua-dismiss": "modal"
            }, " Close"]
          }]
        }, mFooter];
      break;

      case "confirm":
        mFooter = [{
          n: "div",
          c: "col-12 text-end",
          i: [{
            n: "button",
            "ua-response": "No",
            c: "btn btn-primary modal-dia-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            i: ["no"]
          },{
            n: "button",
            c: "btn btn-primary modal-dia-close",
            "data-bs-dismiss": "modal",
            "ua-response": "Yes",
            "aria-label": "Close",
            i: ["Yes"]
          }]
        }, mFooter];
      break;
      case "prompt":
        mFooter = [{
          n: "div",
          c: "col-12 text-end",
          i: [{
            n: "button",
            c: "btn btn-primary modal-dia-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            "ua-response": "Cancel",
            i: ["Cancel"]
          },{
            n: "button",
            c: "btn btn-primary modal-dia-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            "ua-response": "Confirm",
            i: ["Confirm"]
          }]
        }, mFooter];
      break;
      default:
      break;
    }
  }

  var modal = {
    n: "div",
    id: options.id || "",
    c: "modal bg-blur-og-50-background text-primary",
    role: "dialog",
    tabindex: "-1",
    "aria-modal": "true",
    i: {
      n: "div",
      c: "modal-dialog modal-dialog-centered modal-dialog-scrollable" + (options.fullscreen === false ? "" : " modal-fullscreen"),
      i: {
        n: "div",
        c: "modal-content",
        i: [
          modalHeader,
          {
            n: "div",
            c: "modal-body m-3",
            i: options.inner
          },
          {
            n: "div",
            c: "modal-footer p-2",
            i: mFooter
          }
        ]
      }
    }
  };

  if (options.hide) {

    if (!("class" in modal)) {
      modal.class = "";
    }

    modal["aria-hidden"] = "true";
    modal["backdrop"] = "static";
    modal.class += " hide fade ";
    
    if (!("style" in options)) {
      modal.style = "";
    }

    modal.style += "display: none;";

  } else {
    modal.class += " show d-block"; 
  }

  modal["data-ua-dialog-title"] = dialogTitle;
  modal["data-ua-breadcrumb"] = options.breadcrumb === false ? "false" : "true";
  modal["data-ua-lock-parent"] = options.lockParent === false ? "false" : "true";




  // if (myid == false) {
  //   //than output and render the modal as provided.
  //   return await jsonRender.convertJSONToDOM(modal, {
  //     PassthroughOptions: options
  //   });
  // } else {
    //otherwise, we have some work to do.
    //attach our event listerner to the button
    // modal.id = myid;
    
    // modal = await jsonRender.convertJSONToDOM(modal, {
    //   PassthroughOptions: options
    // });

    // var btn = modal.querySelector(".modal-dia-close");

    // console.log("Dialog button is:", {
    //   btn: btn,
    //   modal: modal
    // });

    // btn.addEventListener("click", function() {
    //   modal.remove();
    // });
// modal-backdrop 
    return modal;

  // }

}

events.on("interface.afterrender", async function() {
  //find all the modals that are not hidden, and craft them as bootstrap modals.
  var modals = document.querySelectorAll(".modal.show");
  modals.forEach(function(modal) {
    if (modal.getAttribute("data-ua-dialog-wired") === "true") return;
    modal.setAttribute("data-ua-dialog-wired", "true");
    // console.log("Found a modal to render: ", modal);
    var bsModal = new bootstrap.Modal(modal, {
      backdrop: true,
      keyboard: true,
      focus: true
    });
    bsModal.show();
  });
  updateDialogStackState();
});

/** 
 * 
 * 
 * 
 * <div class="modal show" id="modelLegal" tabindex="-1" aria-labelledby="modelReset" aria-modal="true" role="dialog" style="z-index: 100000; display: block;">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header p-1">
            <div class="col-10">
              <h1 class="modal-title d-flex align-items-center" id="modalReset">
                <span class="mybrand d-inline-block" style="width:4rem; height:4rem; margin-right:1rem;"></span> ${options.title}
              </h1>
            </div>
            <div class="col-2 text-end"><button class="btn btn-text-info"><i class="bi bi-x-circle-fill"></i></button></div>
          </div>
          <div class="modal-body m-3">
            

            ${options.inner}

          </div>
          <div class="modal-footer p-2">

            ${options.footer}
            <!-- <button type="button" class="btn btn-underline-primary" onclick="HideModal('modelLegal')">Accept</button> -->
          </div>
        </div>
      </div>
    </div>
*/

// add a data-ua-dismiss="modal" function handler that removes the modal from the DOM.
document.addEventListener("click", function(event) {
  if (event.target.hasAttribute("data-ua-dismiss") && event.target.getAttribute("data-ua-dismiss") === "modal") {
    // console.log("Modal close button clicked: ", event.target);
    var modal = event.target.closest(".modal");
    if (modal) {
      // console.log("Modal found: ", modal);
      modal.remove();
      updateDialogStackState();
    }
  }
}, false);
